import './tabs.scss';

document.addEventListener('DOMContentLoaded', function() {
	const tabsContainers = document.querySelectorAll('.tabs-stack-wrap');

	tabsContainers.forEach(container => {
		const tabNavigation = container.querySelector('.tabs-navigation');
		const tabContent = container.querySelector('.tabs-content');
		const tabItems = container.querySelectorAll('.tab-details');

		// Create tab navigation items from tab-details elements
		tabItems.forEach((tabItem, index) => {
			const tabId = tabItem.classList[tabItem.classList.length - 1]; // Get the tab ID from class
			const tabTitle = tabItem.querySelector('.tab-title').textContent;

			// Create tab button
			const tabButton = document.createElement('button');
			tabButton.classList.add('tab-nav-button');
			tabButton.setAttribute('role', 'tab');
			tabButton.setAttribute('aria-controls', 'content-' + tabId);
			tabButton.setAttribute('id', 'nav-' + tabId);
			tabButton.textContent = tabTitle;

			// Set first tab as active by default
			if (index === 0) {
				tabButton.classList.add('active');
				tabButton.setAttribute('aria-selected', 'true');
				tabItem.querySelector('.tab-content').removeAttribute('hidden');
				tabItem.classList.add('active');
			} else {
				tabButton.setAttribute('aria-selected', 'false');
				tabItem.querySelector('.tab-content').setAttribute('hidden', '');
			}

			// Add click event
			tabButton.addEventListener('click', () => {
				// Deactivate all tabs
				container.querySelectorAll('.tab-nav-button').forEach(btn => {
					btn.classList.remove('active');
					btn.setAttribute('aria-selected', 'false');
				});

				container.querySelectorAll('.tab-details').forEach(item => {
					item.classList.remove('active');
					item.querySelector('.tab-content').setAttribute('hidden', '');
				});

				// Activate clicked tab
				tabButton.classList.add('active');
				tabButton.setAttribute('aria-selected', 'true');
				tabItem.classList.add('active');
				tabItem.querySelector('.tab-content').removeAttribute('hidden');
			});

			// Add to navigation
			tabNavigation.appendChild(tabButton);
		});

		// Handle keyboard navigation
		tabNavigation.addEventListener('keydown', (e) => {
			const buttons = [...tabNavigation.querySelectorAll('.tab-nav-button')];
			const currentTab = document.activeElement;
			const currentIndex = buttons.indexOf(currentTab);

			switch (e.key) {
				case 'ArrowRight':
					if (currentIndex < buttons.length - 1) {
						buttons[currentIndex + 1].click();
						buttons[currentIndex + 1].focus();
					}
					break;
				case 'ArrowLeft':
					if (currentIndex > 0) {
						buttons[currentIndex - 1].click();
						buttons[currentIndex - 1].focus();
					}
					break;
			}
		});
	});
});